import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=b8b74630"
var script = {}
import style0 from "./CardBody.vue?vue&type=style&index=0&id=b8b74630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports